import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";

import {
  IonCol,
  IonGrid,
  IonItem,
  IonList,
} from "@ionic/react";

import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import useTituloPagina from "../../hooks/tituloPagina";
import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  Card,
  IconButton,
  Typography,
} from "@mui/joy";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import { LinkOutlined, OpenInNew } from "@mui/icons-material";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";
import { IonIcon, IonRow } from "@ionic/react";
import {
  homeOutline,
  filterOutline,
  imageOutline,
  searchOutline,
} from "ionicons/icons";
import Tooltip from "@mui/material/Tooltip";
import { Chip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "../Estudios/EstudiosPaciente.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function ImagenesPaciente() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [tituloPagina, setTituloPagina] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [listadoEstudios, setListadoEstudios] = useState([]);
  const [listadoEstudiosFiltrados, setListadoEstudiosFiltrados] = useState([]);
  const [estudioSel, setEstudioSel] = useState(-1);
  const [listadoEstudiosFiltro, setListadoEstudiosFiltro] = useState([]);
  const [estudioPdf, setEstudioPdf] = useState({
    fecha: "",
    nombre: "",
    doc: {},
  });
  const [abrirModal, setAbrirModal] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState("todos");

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const abrirCerrarModal = () => setAbrirModal(!abrirModal);

  const traerEstudiosPaciente = async (paciente) => {
    let estudios = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}EstudiosImagenes/Paciente?paciente=${paciente.codigo}`,
        config
      );
      if (response.data.length !== 0) {
        estudios = response.data;
      } else {
        estudios = [];
      }

      estudios = estudios.map((estudio, i) => {
        let nombre = estudio.nombre;
        return {
          ...estudio,
          codigo: i,
          fecha: "No disponible",
          text: nombre,
        };
      });
      setListadoEstudios(estudios);
      setListadoEstudiosFiltrados(estudios);
      setListadoEstudiosFiltro(estudios);
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response, "rojo");
    }
  };

  const FiltrarEstudios = (value) => {
    setCargando(true);
    if (value !== -1) {
      let listado = [];

      listadoEstudios.map((estudio) => {
        if (parseInt(value) === estudio.estudioCod) {
          listado.push(estudio);
        }
      });
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listado);
    } else {
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listadoEstudios);
    }
    setCargando(false);
  };

  const BuscarEstudio = async (estudio) => {
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };
    try {
      console.log({ estudio });
      const response = await axios.get(
        `${url}EstudiosImagenes/TraerToken?documentoPaciente=${usuario.documentoNro}&numero=${estudio.numero}&equipo=${estudio.equipo}`,
        config
      );

      if (response.data.length > 0) {
        window.open(response.data, "_blank");
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const VisualizarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerEstudiosPaciente(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const redirecFromLink = (link) => {
    window.open(link, "_blank");
  };

  const handleVolverInicio = () => {
    history.push("/portal/Inicio");
  };

  // Filtrar imágenes por tipo
  const imagenesParaMostrar = (listadoEstudiosFiltrados || []).filter(img => {
    return filtroTipo === "todos" || img.tipoEstudio === filtroTipo;
  });

  // Agrupar imágenes filtradas
  const imagenesAgrupadas = imagenesParaMostrar.reduce((acc, img) => {
    const tipo = img.tipoEstudio || "Sin clasificar";
    if (!acc[tipo]) {
      acc[tipo] = [];
    }
    acc[tipo].push(img);
    return acc;
  }, {});

  // Calcular estadísticas
  const tiposImagen = {};
  (listadoEstudiosFiltrados || []).forEach(img => {
    const tipo = img.tipoEstudio || "Sin clasificar";
    tiposImagen[tipo] = (tiposImagen[tipo] || 0) + 1;
  });

  const renderTurnosLista = () => {
    return (
      <tbody>
        {listadoEstudiosFiltrados.map((fila) => {
          return (
            <tr>
              {/* <Row xs={12} container> */}
              <td>
                <Typography level="title-sm">{fila.estudioNom}</Typography>
              </td>
              <td>
                <Typography level="title-sm">
                  {fila.fecha === "No disponible"
                    ? "No disponible"
                    : `${obtenerNombreDia(
                        dayjs(fila.fecha).format("dddd")
                      )} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                        fila.fecha
                      ).format("MMMM, YYYY")}`}
                </Typography>
              </td>
              <td>
                <IconButton onClick={() => BuscarEstudio(fila)}>
                  <LinkOutlined />
                </IconButton>
              </td>
              {/* </Row> */}
            </tr>
          );
        })}
      </tbody>
    );
  };
  const renderTurnosListaa = (seePreviusVersion) => {
    return (
      <IonList lines="none">
        <IonGrid className="table">
          <IonItem className="fila cabecera amarillo-sol">
            <IonCol className="celda cabecera">
              <IonCol className="celda cabecera">
                <p>Nombre de estudio</p>
              </IonCol>
              <p>Fecha estudio</p>
            </IonCol>
            <IonCol className="celda cabecera">
              <p>Estudio</p>
            </IonCol>
          </IonItem>
          <IonGrid className="">
            {listadoEstudiosFiltrados.map((fila) => (
              <Card style={{ marginBottom: "7.5px", padding: "0px 14px" }}>
                <Row
                  className=""
                  style={{ textAlign: "start" }}
                  alignItems="center"
                  container
                >
                  <Column
                    style={{ textAlign: "start" }}
                    xs={6}
                    md={8}
                    lg={10}
                    container
                  >
                    <Row alignItems="center" container>
                      <Column xs={12} md={6}>
                        <Typography
                          level="title-lg"
                          sx={{ color: "#80c423", fontWeight: "bold" }}
                        >
                          {fila.estudioNom}
                        </Typography>
                      </Column>
                      <Column xs={8} md={3}>
                        <Typography level="title-lg">
                          {fila.fecha === "No disponible"
                            ? "No disponible"
                            : `${obtenerNombreDia(
                                dayjs(fila.fecha).format("dddd")
                              )} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                                fila.fecha
                              ).format("MMMM, YYYY")}`}
                        </Typography>
                      </Column>
                      <Column xs={4} md={3}>
                        <IconButton onClick={() => BuscarEstudio(fila)}>
                          <OpenInNew />
                        </IconButton>
                      </Column>
                    </Row>
                  </Column>
                </Row>
              </Card>
            ))}
          </IonGrid>
        </IonGrid>
      </IonList>
    );
  };

  return (
    <>
      {cargando ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center" style={{ padding: "40px 0" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                  <div className="spinner" style={{ width: "48px", height: "48px", border: "6px solid #e0e7ef", borderTop: "6px solid #a70101", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
                  <p style={{ color: "#a70101", fontWeight: "600", fontSize: "18px", margin: 0 }}>Procesando...</p>
                </div>
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : !listadoEstudios || listadoEstudios.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene imágenes registradas aún</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          {/* HEADER CON TÍTULO Y FILTROS */}
          <div style={{ padding: "16px 16px 0 16px", backgroundColor: "#f8f9fa" }}>
            <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
              borderRadius: "16px",
              padding: "24px",
              marginBottom: "20px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              border: "1px solid rgba(0, 0, 0, 0.06)"
            }}>
              {/* Título Principal con Botón Volver */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
                <div style={{
                  background: "#a70101",
                  borderRadius: "12px",
                  padding: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(167, 1, 1, 0.18)"
                }}>
                  <IonIcon icon={imageOutline} style={{ fontSize: "28px", color: "white" }} />
                </div>
                <div style={{ flex: 1 }}>
                  <h1 style={{
                      margin: 0,
                      fontSize: "24px",
                      fontWeight: "700",
                      color: "#a70101"
                  }}>
                    Mis Imágenes
                  </h1>
                  <p style={{ margin: "4px 0 0 0", color: "#6b7280", fontSize: "14px" }}>
                    {(listadoEstudios || []).length} imagen{(listadoEstudios || []).length !== 1 ? 'es' : ''} disponible{(listadoEstudios || []).length !== 1 ? 's' : ''}
                  </p>
                </div>
                <button 
                  onClick={handleVolverInicio}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "12px 20px",
                    backgroundColor: "white",
                    border: "2px solid #a70101",
                    borderRadius: "12px",
                    color: "#a70101",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 8px rgba(167, 1, 1, 0.10)",
                    position: "relative",
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#a70101";
                    e.target.style.color = "white";
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 4px 12px rgba(167, 1, 1, 0.18)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "white";
                    e.target.style.color = "#a70101";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 2px 8px rgba(25, 118, 243, 0.10)";
                  }}
                >
                  <IonIcon icon={homeOutline} style={{ fontSize: "18px" }} />
                  <span>Volver al inicio</span>
                </button>
              </div>

              {/* Filtros por tipo */}
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                  <IonIcon icon={filterOutline} style={{ fontSize: "18px", color: "#6b7280" }} />
                  <span style={{ fontSize: "14px", fontWeight: "600", color: "#374151" }}>
                    Filtrar por tipo:
                  </span>
                </div>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  <Chip
                    label={`Todos (${(listadoEstudios || []).length})`}
                    onClick={() => setFiltroTipo("todos")}
                    variant={filtroTipo === "todos" ? "filled" : "outlined"}
                    color={filtroTipo === "todos" ? "primary" : "default"}
                    style={{
                      fontWeight: filtroTipo === "todos" ? "600" : "500",
                      cursor: "pointer",
                      transition: "all 0.2s ease"
                    }}
                  />
                  {Object.entries(tiposImagen).map(([tipo, cantidad]) => {
                    const colores = {
                      "Histeroscopia": "#6366f1",
                      "Patología": "#f59e0b",
                      "Ecografía": "#10b981",
                      "Colposcopia": "#8b5cf6",
                    };
                    return (
                      <Chip
                        key={tipo}
                        label={`${tipo} (${cantidad})`}
                        onClick={() => setFiltroTipo(tipo)}
                        variant={filtroTipo === tipo ? "filled" : "outlined"}
                        style={{
                          backgroundColor: filtroTipo === tipo ? (colores[tipo] || "#64748b") : "transparent",
                          borderColor: colores[tipo] || "#64748b",
                          color: filtroTipo === tipo ? "white" : (colores[tipo] || "#64748b"),
                          fontWeight: filtroTipo === tipo ? "600" : "500",
                          cursor: "pointer",
                          transition: "all 0.2s ease"
                        }}
                      />
                    );
                  })}
                </div>
              </div>

              {/* Indicador de resultados filtrados */}
              {filtroTipo !== "todos" && (
                <div style={{
                  marginTop: "16px",
                  padding: "12px",
                  backgroundColor: "#f0f9ff",
                  borderRadius: "8px",
                  border: "1px solid #bae6fd",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}>
                  <span style={{ fontSize: "14px", color: "#0369a1", fontWeight: "500" }}>
                    {imagenesParaMostrar.length} {filtroTipo} encontrada{imagenesParaMostrar.length !== 1 ? 's' : ''}
                  </span>
                  <button
                    onClick={() => setFiltroTipo("todos")}
                    style={{
                      marginLeft: "auto",
                      padding: "4px 12px",
                      backgroundColor: "white",
                      border: "1px solid #0369a1",
                      borderRadius: "6px",
                      color: "#0369a1",
                      fontSize: "12px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.2s ease"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#0369a1";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "white";
                      e.target.style.color = "#0369a1";
                    }}
                  >
                    Limpiar filtro
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* ACORDEONES DE IMÁGENES */}
          <div style={{ padding: "0 16px 16px 16px", backgroundColor: "#f8f9fa" }}>
            {Object.entries(imagenesAgrupadas).length === 0 ? (
              <div style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "40px 20px",
                textAlign: "center",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)"
              }}>
                <IonIcon icon={searchOutline} style={{ fontSize: "48px", color: "#d1d5db", marginBottom: "12px" }} />
                <h3 style={{ margin: "0 0 8px 0", color: "#6b7280", fontSize: "18px", fontWeight: "600" }}>
                  No se encontraron imágenes de este tipo
                </h3>
                <p style={{ margin: 0, color: "#9ca3af", fontSize: "14px" }}>
                  Intenta seleccionando otro filtro
                </p>
              </div>
            ) : (
              Object.entries(imagenesAgrupadas).map(([tipoImagen, imagenes]) => {
                // Definir colores por tipo de imagen
                const getImagenColor = (tipo) => {
                  const colores = {
                    "Histeroscopia": {
                      primary: "#6366f1",
                      secondary: "#e0e7ff",
                      icon: "🔬",
                    },
                    "Patología": {
                      primary: "#f59e0b",
                      secondary: "#fef3c7",
                      icon: "📋",
                    },
                    "Ecografía": {
                      primary: "#10b981",
                      secondary: "#d1fae5",
                      icon: "📡",
                    },
                    "Colposcopia": {
                      primary: "#8b5cf6",
                      secondary: "#f3e8ff",
                      icon: "🔍",
                    },
                  };
                  return (
                    colores[tipo] || {
                      primary: "#64748b",
                      secondary: "#f1f5f9",
                      icon: "🖼️",
                    }
                  );
                };

                const colorConfig = getImagenColor(tipoImagen);

                return (
                  <AccordionGroup
                    key={tipoImagen}
                    variant="plain"
                    sx={{ marginBottom: "24px" }}
                  >
                    <Accordion
                      variant="plain"
                      sx={{
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        borderRadius: "12px",
                        overflow: "hidden",
                        backgroundColor: "white",
                      }}
                    >
                      {/* Header del tipo de imagen como AccordionSummary */}
                      <AccordionSummary
                        sx={{
                          background: `linear-gradient(135deg, ${colorConfig.primary} 0%, ${colorConfig.primary}dd 100%)`,
                          color: "white",
                          padding: "16px 20px",
                          minHeight: "72px",
                          "&:hover": {
                            background: `linear-gradient(135deg, ${colorConfig.primary}ee 0%, ${colorConfig.primary}cc 100%)`,
                          },
                          "& .MuiAccordionSummary-button": {
                            cursor: "pointer",
                          },
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            width: "100%",
                          }}
                        >
                          <span style={{ fontSize: "24px" }}>
                            {colorConfig.icon}
                          </span>
                          <Typography
                            level="title-lg"
                            sx={{ color: "white", fontWeight: 600, flex: 1 }}
                          >
                            {tipoImagen}
                          </Typography>
                          <div
                            style={{
                              backgroundColor: "rgba(255,255,255,0.2)",
                              borderRadius: "16px",
                              padding: "4px 12px",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            {(imagenes || []).length}{" "}
                            {(imagenes || []).length === 1 ? "imagen" : "imágenes"}
                          </div>
                        </div>
                      </AccordionSummary>

                      {/* Lista de imágenes como AccordionDetails */}
                      <AccordionDetails sx={{ padding: 0 }}>
                        <div
                          style={{
                            backgroundColor: "white",
                          }}
                        >
                          {(imagenes || []).map((img, index) => (
                            <div
                              key={img.codigo}
                              style={{
                                padding: "20px",
                                borderBottom:
                                  index < (imagenes || []).length - 1
                                    ? `1px solid ${colorConfig.secondary}`
                                    : "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "16px",
                                transition: "all 0.2s ease",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  colorConfig.secondary;
                                e.currentTarget.style.transform =
                                  "translateX(4px)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "white";
                                e.currentTarget.style.transform = "translateX(0)";
                              }}
                            >
                              {/* Indicador visual */}
                              <div
                                style={{
                                  width: "4px",
                                  height: "48px",
                                  backgroundColor: colorConfig.primary,
                                  borderRadius: "2px",
                                  flexShrink: 0,
                                }}
                              />

                              {/* Contenido de la imagen */}
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <Typography
                                  level="title-sm"
                                  sx={{
                                    color: "#1f2937",
                                    fontWeight: 600,
                                    marginBottom: "4px",
                                    display: "block",
                                  }}
                                >
                                  {img.text && img.text.length > 40
                                    ? img.text.substring(0, 40) + "..."
                                    : img.text || "Sin nombre"}
                                </Typography>
                                <Typography
                                  level="body-xs"
                                  sx={{
                                    color: "#6b7280",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  📅 {img.fecha}
                                </Typography>
                              </div>

                              {/* Acciones */}
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  flexShrink: 0,
                                }}
                              >
                                <Tooltip title="Visualizar" arrow placement="top">
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      VisualizarPdf(img);
                                    }}
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      backgroundColor: colorConfig.primary,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1.1)";
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 12px rgba(0,0,0,0.2)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1)";
                                      e.currentTarget.style.boxShadow =
                                        "0 2px 8px rgba(0,0,0,0.1)";
                                    }}
                                  >
                                    <VisibilityIcon
                                      sx={{ color: "white", fontSize: "20px" }}
                                    />
                                  </div>
                                </Tooltip>
                              </div>
                            </div>
                          ))}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </AccordionGroup>
                );
              })
            )}
          </div>

          <CustomToast
            openToast={toast.open}
            onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
            message={toast.mensaje}
            colorNotificacion={toast.tipo}
          />
        </>
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
